// extracted by mini-css-extract-plugin
module.exports = {"root":"Backdrop-root-1vgxJ","active":"Backdrop-active-2gkKs"};